import script from "./OcupacoesSolo.vue?vue&type=script&setup=true&lang=js"
export * from "./OcupacoesSolo.vue?vue&type=script&setup=true&lang=js"

import "./OcupacoesSolo.vue?vue&type=style&index=0&id=0e2917f3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2917f3"]])

export default __exports__